import loadable from '@loadable/component';

export const BuyCreditsContainerLoadable = loadable(
  () => import('./BuyCreditsContainer'),
  { resolveComponent: (module) => module.BuyCreditsContainer, ssr: false },
);
